import { render, staticRenderFns } from "./UpdateRecipeCost.vue?vue&type=template&id=0c7b4e72&scoped=true"
import script from "./UpdateRecipeCost.vue?vue&type=script&lang=ts"
export * from "./UpdateRecipeCost.vue?vue&type=script&lang=ts"
import style0 from "./UpdateRecipeCost.vue?vue&type=style&index=0&id=0c7b4e72&prod&scoped=true&lang=css"
import style1 from "./UpdateRecipeCost.vue?vue&type=style&index=1&id=0c7b4e72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7b4e72",
  null
  
)

export default component.exports